import {Vector3} from 'three'

import {CORNER_RADIUS} from '../../modules/cube/_config'
import type {LayoutConfig} from '../../modules/cube/_types'
const leftPosition = new Vector3(-10.7, -1, 0.0)

const calcPosition = (pos: Vector3) => {
  pos.add(leftPosition)
  pos.x *= 1.0 + CORNER_RADIUS
  pos.y *= 1.0 + CORNER_RADIUS
  pos.z *= 1.0 + CORNER_RADIUS

  return pos
}

const offsetStart = {
  position: new Vector3(0, -4, 0),
  rotation: new Vector3(-Math.PI, 0, 0),
}

const commonCubeConfig = {
  offsetStart,
  delay: 0.0,
  duration: 1,
  scale: 1,
}

const tabletOffset = 0.5
const mobileOffset = 1.2

const cubes = [
  // Left
  {
    position: calcPosition(new Vector3(0.0, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: false,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(1, 0.0, 0.0)),
    rotation: new Vector3(-Math.PI / 2, 0, 0.0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: false,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(2, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: false,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(3, 0.0, 0.0)),
    rotation: new Vector3(-Math.PI / 2, 0, 0.0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(4, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(5, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'glass',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(6.7, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(mobileOffset, 0, 0),
        visible: true,
      },
    },
  },

  //Right
  {
    position: calcPosition(new Vector3(14, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(-tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(-mobileOffset, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(15, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'glass',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(-tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(-mobileOffset, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(16, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(-tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(-mobileOffset, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(17, 0.0, 0.0)),
    rotation: new Vector3(-Math.PI / 2, 0, 0.0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(-tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(-mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(18, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(-tabletOffset, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(-mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(20, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(-tabletOffset, 0, 0),
        visible: false,
      },
      mobile: {
        offset: new Vector3(-mobileOffset, 0, 0),
        visible: false,
      },
    },
  },
]

const valley = (x: number) => {
  return Math.abs(2 * x - 1)
}

cubes.forEach((cube, index) => {
  const p = index / (cubes.length - 1)
  cube.delay = valley(p)
  cube.duration = 1
})

export default {
  rotation: new Vector3(Math.PI * 0.25, -Math.PI * 0.2, 0),
  rotationOrder: 'YXZ',
  groupAnim: {
    start: new Vector3(0, -0.5, 0),
    end: new Vector3(0, 0, 0),
    duration: 4.0,
    ease: 'expo.out',
  },
  cubes,
} as LayoutConfig
